function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#50DB98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.79883 9.70893H7.1157C7.12445 9.91893 7.20904 10.0954 7.36945 10.2383C7.53279 10.3812 7.75591 10.4527 8.03883 10.4527C8.30716 10.4527 8.52445 10.3943 8.6907 10.2777C8.85695 10.1581 8.94154 9.99913 8.94445 9.8008C8.95029 9.64622 8.9007 9.51205 8.7957 9.3983C8.6907 9.28455 8.49237 9.18538 8.2007 9.1008L7.45695 8.89518C6.39237 8.56559 5.86008 7.97351 5.86008 7.11893C5.86008 6.62309 6.03362 6.20893 6.3807 5.87643C6.72779 5.54393 7.16966 5.34997 7.70633 5.29455V4.33643H8.36258V5.3033C8.873 5.3733 9.2857 5.57309 9.6007 5.90268C9.9157 6.23226 10.0732 6.65372 10.0732 7.16705H8.76508C8.76508 6.95705 8.69508 6.78788 8.55508 6.65955C8.41799 6.53122 8.22258 6.46705 7.96883 6.46705C7.73841 6.46705 7.54737 6.52538 7.3957 6.64205C7.24404 6.7558 7.1682 6.90309 7.1682 7.08393C7.1682 7.37851 7.38987 7.58851 7.8332 7.71393L8.5682 7.9458C9.7232 8.2783 10.2876 8.89955 10.2613 9.80955C10.2584 10.0779 10.203 10.3214 10.0951 10.5402C9.99008 10.7589 9.84716 10.9412 9.66633 11.0871C9.48841 11.23 9.28862 11.3452 9.06695 11.4327C8.8482 11.5173 8.61341 11.5727 8.36258 11.5989V12.6314H7.70633V11.5989C7.12591 11.5406 6.66216 11.3393 6.31508 10.9952C5.97091 10.6481 5.79883 10.2193 5.79883 9.70893Z",
  fill: "white"
});

var SvgUsdSign = function SvgUsdSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsdSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usdSign.4a84f03a.svg";
export { ForwardRef as ReactComponent };